import { Component, EventEmitter, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
  selector: 'app-filter-icon-button',
  templateUrl: './filter-icon-button.component.html',
  standalone: false,
})
export class FilterIconButtonComponent extends AppBaseComponent {
  @Output() filter = new EventEmitter<boolean>();

  onClick(): void {
    this.filter.emit(true);
  }
}